<template>
    <v-card>
        <v-tabs v-model="tab" centered>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#res">
                Residencial
            </v-tab>
            <v-tab href="#com">
                Comercial
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item value="res">
                <EnderecoResidencial :listaPaises="paises"/>
            </v-tab-item>
            <v-tab-item value="com">
                <EnderecoComercial :listaPaises="paises"/>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
    import EnderecoResidencial from '@/components/iniciados/EnderecoResidencial'
    import EnderecoComercial from '@/components/iniciados/EnderecoComercial'
    export default{
        props:['paises'],
        components:{EnderecoResidencial, EnderecoComercial},
        data(){
            return{
                tab: {}
            }
        },
        watch:{
            
        },

        created(){
            
            
        }
    }
</script>

<style scoped>
</style>
